import { render } from "./EligibilityCheck.vue?vue&type=template&id=548aeb9c&ts=true"
import script from "./EligibilityCheck.ts?vue&type=script&lang=ts&external"
export * from "./EligibilityCheck.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__